"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getOutputAddonsReport = _interopRequireDefault(require("./getOutputAddonsReport"));
var _getAddonsList = _interopRequireDefault(require("./getAddonsList"));
var _getAddonsTotalCost = _interopRequireDefault(require("./getAddonsTotalCost"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var getOutputSummary = function getOutputSummary(output) {
  var addons = (0, _getOutputAddonsReport["default"])(output);
  var addonsList = (0, _getAddonsList["default"])(addons);
  var totalCost = (0, _getAddonsTotalCost["default"])(addonsList);
  return {
    addons: addons,
    addonsList: addonsList,
    totalCost: totalCost
  };
};
var _default = getOutputSummary;
exports["default"] = _default;